export const bsBlocked = false;
export const vintageYear = 1960;
export const discountCodeMaxLength = 8;
